import { Helmet } from "react-helmet-async";

const SITE_URL = "https://30ahealthins.com";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_coastal-health-plans/artifacts/t0jfyhgk_30a-health-insurance-badge-logo-1200x630.png";

export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  schema,
}) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title
    ? `${title} | 30A Health Insurance`
    : "30A Health Insurance | Local Broker on Florida's Emerald Coast";
  const desc =
    description ||
    "Independent health insurance broker serving Santa Rosa Beach, Destin, Miramar Beach, Panama City Beach, and Freeport, FL. ACA, Medicare Advantage, Medicare Supplement, Dental and short-term coverage.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="30A Health Insurance" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};
